import React from "react";
import { SGridContainer, SPowerdByText } from "./styles";
import { ReactComponent as QuantumLogo } from "../../../assets/logoQuantum.svg";

export const QuantumBanner: React.FC = () => {
  return (
    <SGridContainer>
      <SPowerdByText>Powered by:</SPowerdByText>
      <QuantumLogo />
    </SGridContainer>
  );
};
